import CandidateDetail from "@/pages/app/CandidateDetail";
import { useAuth } from "@/context/AuthContext";

export default function CandidateProfile() {
  const { user } = useAuth();
  return <CandidateDetail selfId={user?.candidate_id} />;
}
